'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectInput = function (_React$Component) {
  _inherits(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoading: false,
      error: false,
      options: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectInput, [{
    key: 'loadOptions',
    value: function loadOptions(source) {
      var _this2 = this;

      this.setState({ isLoading: true, error: false });
      _axios2.default.request(source).then(function (response) {
        if (source === _this2.props.source) {
          _this2.setState({
            options: response.data,
            isLoading: false,
            error: false
          });
        }
      }).catch(function (error) {
        _this2.setState({
          isLoading: false,
          error: 'Error loading options'
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.source) {
        this.loadOptions(this.props.source);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.source !== this.props.source) {
        this.loadOptions(props.source);
      }
    }
  }, {
    key: 'handleOpen',
    value: function handleOpen() {
      if (this.props.source && this.state.error) {
        this.loadOptions(this.props.source);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          _props$clearable = _props.clearable,
          clearable = _props$clearable === undefined ? false : _props$clearable,
          _onChange = _props.onChange,
          options = _props.options,
          placeholder = _props.placeholder,
          _onOpen = _props.onOpen,
          readOnly = _props.readOnly,
          rest = _objectWithoutProperties(_props, ['clearable', 'onChange', 'options', 'placeholder', 'onOpen', 'readOnly']);

      var selectOptions = options || this.state.options;
      return _react2.default.createElement(_reactSelect2.default, _extends({}, rest, {
        onOpen: function onOpen() {
          _this3.handleOpen();
          _onOpen && _onOpen();
        },
        placeholder: this.state.error || placeholder,
        isLoading: this.state.isLoading,
        className: 'Select',
        clearable: clearable,
        disabled: readOnly,
        onChange: function onChange(option) {
          return _onChange && _onChange(option && option.value);
        },
        options: selectOptions }));
    }
  }]);

  return SelectInput;
}(_react2.default.Component);

exports.default = SelectInput;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/@geopagos/gp-forms/lib/inputs/SelectInput.js
// module id = 245
// module chunks = 0